import PricingPlanHeader from "components/PricingPlanDetails/PricingPlanHeader";
import PricingPlanBody from "components/PricingPlanDetails/PricingPlanBody";
import { Heading } from "../../components";
import PricingPlanDetails from "../../components/PricingPlanDetails";
import React, { Suspense } from "react";

const planFeaturesList = [
  {
    plantitle: "Starter",
    pricedescription: "Price for:",
    pricedetails: (
      <>
        Per machine
        <br />
        Compressor
        <br />
        Chillers
        <br />
        Manual Machine (Lathe, Welding, Milling)
        <br />
        Rotary Machine (Pumps)
      </>
    ),
    selectplanbuttontext: "Select Plan",
    corefeaturestitle: "Core features ",
    image: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription1: "Realtime Data from Vibration and current sensorssss",
    alarmsand: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription2: "Alarms and events ",
    imageone: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription3: "Metric (OEE) forecasting",
    imagetwo: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription4: "3-level role-based dashboard access for up to 10 users ",
    imagethree: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription5: "Dashboard parameters: OEE, TPE, cycle time, Predictive maintenance",
    supporttitle: "Support on:",
    supportoption1: "Whatsapp",
    supportoption2: "Phone",
    bestfortitle: "Best for",
    bestfordescription: "Small businesses with few machines needing productivity monitoring",
  },
  {
    plantitle: "Tier 1: Basic/Machine Digital Twin",
    pricedescription: "Price for:",
    pricedetails: (
      <>
        Per machine
        <br />
        CNC machines (Siemens, Fanuc, Haas)
        <br />
        Scanning Electron Microscopes, High-end Lab Equipments
      </>
    ),
    selectplanbuttontext: "Select Plan",
    corefeaturestitle: "Core features",
    image: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription1: "Realtime Data from controller",
    alarmsand: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription2: "Alarms and events ",
    imageone: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription3: "Metric (OEE) calculation",
    imagetwo: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription4: "3-level role-based dashboard access for up to 10 users ",
    imagethree: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription5: "Dashboard parameters: OEE, TPE, cycle time, total parts",
    featuredescription6: "Tool Utilization",
    featuredescription7: "% Air",
    featuredescription8: "Travel",
    featuredescription9: "Motor Temperature",
    supporttitle: "Support on:",
    supportoption1: "Whatsapp",
    supportoption2: "Phone",
    bestfortitle: "Best for",
    bestfordescription: "Small businesses with advanced machines and equipment",
    // supportoption1: "Whatsapp",
    // supportoption2: "Phone",
  },
  {
    plantitle: "Tier 2: Advanced AI / Machine digital twins*",
    pricedescription: "Price for:",
    pricedetails: (
      <>
        Per machine
        <br />
        CNC machines (Siemens, Fanuc, Haas)
        <br />
        Scanning Electron Microscopes, High-end Lab Equipment
      </>
    ),
    selectplanbuttontext: "Select Plan",
    corefeaturestitle: "Core features",
    image: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription1: "Realtime Data from controller",
    alarmsand: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription2: "Alarms and events ",
    imageone: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription3: "Metric (OEE) calculation",
    imagetwo: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription4: "Machine Prescriptive Feedback ",
    featuredescription5: "3-level role-based dashboard access for up to 50 users ",
    imagethree: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription6: "Dashboard parameters: OEE, TPE, cycle time, total parts",
    featuredescription7: "Root Cause Analysis (with AI Assist)",
    supporttitle: "Support on:",
    supportoption1: "Whatsapp",
    supportoption2: "Phone",
    bestfortitle: "Best for",
    bestfordescription: "Medium sized businesses looking to reduce downtime",
    // supportoption1: "Whatsapp",
    // supportoption2: "Phone",
  },
  {
    plantitle: "Tier 3: Professional / Smart Factory Twin",
    pricedescription: "Price for:",
    pricedetails: (
      <>
        Per shopfloor*
        <br />
        Some Features may need additional harware(GPUs, Cameras, RFID Sensor, RFID Reader/writter)
      </>
    ),
    selectplanbuttontext: "Select Plan",
    corefeaturestitle: "Core features",
    image: "images/img_checkmark.svg",
    featuredescription1: "Shopfloor environment monitoring (temperature, humidity, luminescence)",
    alarmsand: "images/img_checkmark.svg",
    featuredescription2: "Job tracking (IoT / RFID based)* and process metrics(OEE, throughput) ",
    imageone: "images/img_checkmark.svg",
    featuredescription3: "Forecasting for metrics",
    imagetwo: "images/img_checkmark.svg",
    featuredescription4: "Bottleneck identification",
    imagethree: "images/img_checkmark.svg",
    featuredescription5: "3-level role-based dashboard access for up to 50 users",
    supporttitle: "Support on:",
    supportoption1: "Whatsapp",
    supportoption2: "Phone",
    supportoption3: "Email",
    bestfortitle: "Best for",
    bestfordescription: "Growing businesses needing enhanced real-time order tracking and shop floor management",
    // featuredescription1: "Shopfloor environment monitoring (temperature, humidity, luminescence)",
    // featuredescription2: "Job tracking (IoT / RFID based)* and process metrics (OEE, throughput)",
    // featuredescription3: "Forecasting for metrics",
    // featuredescription4: "Bottleneck identification",
    // featuredescription5: "3-level role-based dashboard access for up to 50 users",
  },
  {
    plantitle: "Tier 4: Enterprise / Customization",
    pricedescription: "Price for:",
    pricedetails: (
      <>
        Data acquisition & setup :<br />
        Custom pricing
        <br />
        Model development for niche processes
        <br />
        IoT customization for specialized applications: Custom pricing
      </>
    ),
    selectplanbuttontext: "Select Plan",
    corefeaturestitle: "All Professional features:",
    image: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription1: "Custom features integration: Access to additional integrations with factory ERP",
    alarmsand: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription2: "Custom integrations and API access ",
    imageone: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription3: "",
    imagetwo: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription4: "",
    imagethree: "images/img_teenyicons_tick_circle_solid.svg",
    featuredescription5: "",
    supporttitle: "Support on:",
    supportoption1: "Dedicated account manager",
    supportoption2: "24/7 Phone",
    supportoption3: "Email",
    bestfortitle: "Best for",
    bestfordescription: "Large organizations with complex needs",
  },
];

export default function SolutionsSection() {
  return (
    <div className="mt-40 py-6 flex flex-col items-center">
      <div className="container-xs flex flex-col gap-24 px-2.5 md:gap-[72px] md:px-[50px] sm:gap-12 sm:px-5">
        {/* Heading Section */}
        <div className="mr-2 flex justify-center px-14 md:mr-0 md:px-5">
          <Heading
            as="h2"
            className="w-full text-center font-spacegrotesk text-[46px] font-bold leading-[46px] text-color_style-01_neutrals-grey800 md:w-[70%] md:text-[42px] sm:text-[24px] sm:leading-[31px]"
          >
            <span className="font-medium">Choose the right plan</span>
            <span>&nbsp;for your industry</span>
          </Heading>
        </div>

        {/* Pricing Plan Header Section */}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 auto-rows-min">
          <Suspense fallback={<div>Loading feed...</div>}>
            {planFeaturesList.map((d, index) => (
              <PricingPlanHeader {...d} key={"header" + index} />
            ))}
          </Suspense>
        </div>

        {/* Pricing Plan Content Section */}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 auto-rows-auto">
          <Suspense fallback={<div>Loading feed...</div>}>
            {planFeaturesList.map((d, index) => (
              <PricingPlanBody {...d} key={"content" + index} />
            ))}
          </Suspense>
        </div>
      </div>
    </div>
  );
}
